import { render, staticRenderFns } from "./TableHeaderBasic.vue?vue&type=template&id=7068cf33&scoped=true&"
import script from "./TableHeaderBasic.vue?vue&type=script&lang=js&"
export * from "./TableHeaderBasic.vue?vue&type=script&lang=js&"
import style0 from "./TableHeaderBasic.vue?vue&type=style&index=0&id=7068cf33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7068cf33",
  null
  
)

export default component.exports